import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';
import noRatingsIcon from 'public/static/images/comparisons/no-ratings.svg';

export default css`
  .box {
    display: flex;
    flex-direction: column;
    width: 45%;
    align-items: center;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .box {
      flex-direction: row;
    }
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .box {
      align-items: flex-start;
    }
  }

  .icon {
    background-image: url(${noRatingsIcon});
    background-size: cover;
    min-width: 80px;
    width: 80px;
    height: 80px;
    margin-bottom: 8px;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .icon {
      width: 102px;
      height: 102px;
      min-width: 102px;
      margin-right: 15px;
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .icon {
      min-width: 115px;
      width: 115px;
      height: 115px;
    }
  }

  .rating-text {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .rating-text {
      align-items: initial;
    }
  }

  .no-ratings {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.19px;
    color: ${colors.G3};
    text-transform: uppercase;
    margin-bottom: 11px;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .no-ratings {
      font-size: 18px;
      letter-spacing: 0.21px;
      margin-bottom: 16px;
      line-height: 20px;
    }
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .no-ratings {
      margin-bottom: 3px;
    }
  }

  .would-buy-again {
    display: none;
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .would-buy-again {
      display: block;
      font-size: 18px;
      font-weight: 600;
      color: ${colors.BLACK};
      margin-bottom: 16px;
    }
  }

  .review-link {
    width: 160px;
    height: 48px;
    border-radius: 8px;
    border: 2px solid ${colors.G1};
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
  }

  .review-link:hover {
    color: white;
    background-color: ${colors.ALR1};
    border: 2px solid ${colors.ALR1};
  }
`;
